import React from "react";

type Props = {
  value: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
};

export const BooleanField: React.FC<Props> = ({
  value,
  onChange,
  disabled,
}) => {
  return (
    <label
      className={`tw-flex tw-items-center tw-gap-2 ${
        disabled ? "tw-cursor-not-allowed" : "tw-cursor-pointer"
      }`}
    >
      <input
        type="checkbox"
        checked={value || false}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
        className="tw-form-checkbox tw-h-4 tw-w-4 tw-rounded
          tw-border-gray-400 tw-text-blue-600
          focus:tw-ring-2 focus:tw-ring-blue-500
          disabled:tw-border-gray-200 disabled:tw-text-gray-200 disabled:tw-cursor-not-allowed"
      />
      <span
        className={`tw-text-sm ${
          disabled ? "tw-text-gray-500" : "tw-text-gray-700"
        }`}
      >
        {value ? "Yes" : "No"}
      </span>
    </label>
  );
};
